import { Button } from '@atoms';
import { CloseIcon } from '@atoms/Icons/CloseIcon';
import { Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
interface IModalProps {
  onCancel: () => void;
  open: boolean;
  onConfirm: () => void;
}

export const ConfirmEnforceModal = ({ open, onCancel, onConfirm }: IModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title=""
      maxWidth="md"
      PaperProps={{
        sx: {
          width: '658px !important',
          borderRadius: '24px',
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box py="24px" px="32px" height="100%" width="100%">
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h5"></Typography>
            <IconButton
              onClick={onCancel}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: '24px',
                lineHeight: '20px',
                color: '#464F60',
                whiteSpace: 'normal',
                marginBottom: '32px',
              }}
            >
              Confirm Enforcement
            </Typography>
            <Typography
              sx={{
                fontSize: '16px',
                lineHeight: '20px',
                color: '#464F60',
                whiteSpace: 'normal',
              }}
            >
              Do you confirm that you submitted the enforcement?
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ border: '1px solid #E1E1E1' }}>
        <Button
          variant="text"
          color="inherit"
          onClick={onCancel}
          sx={{
            width: 'fit-content',
            paddingX: '10px',
            borderRadius: '10px',
            marginTop: '8px',
            marginBottom: '12px',
          }}
        >
          <Box component="div" display="flex" gap={1.25}>
            <Typography component="span" color="text.white" variant="body2">
              Cancel
            </Typography>
          </Box>
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={onConfirm}
          sx={{
            width: 'fit-content',
            paddingX: '30px',
            paddingY: '10px',
            borderRadius: '10px',
            marginTop: '8px',
            marginBottom: '12px',
          }}
        >
          <Typography component="span" color="text.white" variant="body2">
            Confirm
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
